/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Label from "../../components/label";
import InstantHushLogo from "../../assets/images/instant_hush_logo.png";
import appRoutes from "../../routes/appRoutes";
import { connect } from "react-redux";
import Model from "../../components/customModal";
import {
  addConsultNoteStep2ApiRoute,
  getOrderHistoryInstantHushAPI,
  ihChangeOnlineAssessmentStatusAPI,
  submitIHOnlineAssessmentAPI
} from "../../apiRoutes";
import MakeAPICall from "../../apiCalls/common";
import Loader from "../../components/loader";
import ViewAssessment from "../../containers/InstantSwitch/ViewAssessment/viewAssessment";
import { setOnlineAssessmentStatus } from "../../reduxStore/actions/commonAction";

// containers
import Prescription from "../../containers/InstantSwitch/Prescription/Prescription";
import TreatmentPlanSelectionForm
  from "../../containers/InstantHush/TreatmentPlanSelectionForm/TreatmentPlanSelectionForm";
import {
  deleteDrugInfo,
  deleteNoteAttachment,
  removeAssessmentData,
  saveDrugInfo,
  saveNoteAttachment
} from "../../reduxStore/actions/auth";

import ICButton from "../../components/button";
import ICInput from "../../components/form/input";
import { ORDER_HISTORY_FILTERS } from "../../constants/helperConstants";
import ICCheckbox from "../../components/form/checkbox";

class IhAssessmentViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: props.auth,
      currentStep: 1, // TODO: change to step 1 as default
      assessmentId: props.location.state && props.location.state._id ? props.location.state._id : null,
      assessmentData: null,
      apiCall: null,
      apiLoading: true,
      isSuccessModelOpen: false,
      showRejectAssessmentConfirmationModel: false, // rejection button on step 1 - confirmation model
      selectedType: [], // doctor selected treatment plans
      additionalNoteForConsultNote: "", // for consult notes
      additionalNoteForPatient: "" // this one will go with email

    };
  };

  componentDidMount() {
    this.setState({
      apiLoading: true
    });
    const assessmentId = this.props.location.state && this.props.location.state._id ? this.props.location.state._id : null;
    this.getAssessmentDetails(assessmentId);
  }

  increaseCurrentStep() {
    this.setState({
      currentStep: this.state.currentStep + 1
    });
  }

  decreaseCurrentStep() {
    this.setState({
      currentStep: this.state.currentStep - 1
    });
  }

  async getAssessmentDetails(assessmentId) {
    const param = {
      assessmentId: assessmentId
    };
    let apiCallParam = {
      reqType: "GET",
      reqURL: getOrderHistoryInstantHushAPI,
      dataObj: {},
      params: param,
      headers: {},
      successCallback: res => {
        console.log("Got the assessment details: ", res);
        this.setState({
          apiLoading: false,
          assessmentData: res.data.data.orderHistoryData[0]
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  async goBack() {
    await this.props.setOnlineAssessmentStatus(false);
    await this.props.removeAssessmentData();
    this.props.history.goBack();
  }

  // Instant Hush Assessment Rejection

  toggleRejectConfirmationModel() {
    this.setState({
      showRejectAssessmentConfirmationModel: !this.state.showRejectAssessmentConfirmationModel
    });
  }

  rejectOnlineAssessment() {
    this.setState({
      apiLoading: true
    });

    this.toggleRejectConfirmationModel();

    const dataToSend = {
      assessmentId: this.state.assessmentId,
      assessmentStatus: ORDER_HISTORY_FILTERS.REJECTED
    };

    let apiCallParam = {
      reqType: "POST",
      reqURL: ihChangeOnlineAssessmentStatusAPI,
      dataObj: dataToSend,
      params: {},
      headers: {},
      successCallback: res => {
        this.props.removeAssessmentData();
        console.log("Assessment Submitted Successfully");
        this.setState({
          apiLoading: false
        });
        this.goBack();
      },
      failureCallback: err => {
        console.log("Error while submitting Assessment Submitted Successfully : ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  deleteAttachment(attachment, index) {
    this.props.deleteNoteAttachment(attachment);
    if (this.props.prescriptionDrugs && this.props.prescriptionDrugs[attachment.selectedTypes]) {
      let allDrugInfo = this.props.prescriptionDrugs[attachment.selectedTypes]["drugs"];
      const filterDeletedDrug = allDrugInfo.filter(
        item => ((item.name !== attachment.drugInfo.name) && (item.quantity !== attachment.drugInfo.quantity) && (item.strength !== attachment.drugInfo.strength))
      );
      let drugInfoToSave = this.props.prescriptionDrugs;
      drugInfoToSave[attachment.selectedTypes]["drugs"] = filterDeletedDrug;
      this.props.deleteDrugInfo(drugInfoToSave);
    }
  }

  // first step complete event
  addSelectedType(types) {
    console.log("Doctor has selected this treatments: - ", types);
    this.setState({
      selectedType: types
    });
    this.increaseCurrentStep();
  }

  // step 2 functions
  togglePrescriptionComponent() {
    this.setState({
      isPrescriptionFormVisible: !this.state.isPrescriptionFormVisible
    });
  }

  openAttachment(attachment) {
    window.open(attachment.url, "_blank");
  }

  // step 3 - final step functions
  handleSubmitAssessment() {
    this.setState({
      apiLoading: true
    });
    console.log("Now submitting assessment");

    let formData = new FormData();
    formData.append("patientId", this.state.assessmentData.patientId._id);
    formData.append("note", "Patient understands and consents to the nature and limitations of a telemedicine consultation\nPatient ID, DOB and address confirmed\n\n Find attached online assessment and recommended treatment plan \n\n" + this.state.additionalNoteForConsultNote);
    formData.append("templates", JSON.stringify(this.props.attachments));
    formData.append("isInstantHush", true);
    formData.append("onlineAssessmentId", this.state.assessmentData._id);

    let apiCallParam = {
      reqType: "POST",
      reqURL: addConsultNoteStep2ApiRoute,
      dataObj: formData,
      params: {},
      headers: {},
      successCallback: res => {
        console.log("COnsult note added successfully: ", res);
        this.sendAssessmentEmailToPatient(res.data.data._id);
        // this.setState({
        //     apiLoading: false
        // });
      },
      failureCallback: err => {
        console.log("Somethign went wrong during consult note step 2: ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  sendAssessmentEmailToPatient(consultNoteId) {
    console.log("Now sending assessment email to patient");
    this.setState({
      apiLoading: true
    });

    // const dataToSend = {
    //     assessmentId: this.state.assessmentId,
    //     types: JSON.stringify(this.state.selectedType),
    //     additionalNoteForEmail: this.state.additionalNoteForPatient,
    //     drugs: this.props.prescriptionDrugs,
    //     consultNoteId: consultNoteId,
    // };

    let formData = new FormData();
    formData.append("assessmentId", this.state.assessmentId);
    formData.append("types", JSON.stringify(this.state.selectedType));
    formData.append("additionalNoteForEmail", this.state.additionalNoteForPatient);
    formData.append("drugs", JSON.stringify(this.props.prescriptionDrugs));
    formData.append("consultNoteId", consultNoteId);
    console.log("submit", {
      "assessmentId": this.state.assessmentId, "types": JSON.stringify(this.state.selectedType),
      "additionalNoteForEmail": this.state.additionalNoteForPatient,
      "drugs": JSON.stringify(this.props.prescriptionDrugs),
      "medicareCostId": this.state.selectedMedicareDuration, "consultNoteId": consultNoteId,
      "patientAttachedPDF": this.state.patientAttachedPDF
    });

    let apiCallParam = {
      reqType: "POST",
      reqURL: submitIHOnlineAssessmentAPI,
      // dataObj: dataToSend,
      dataObj: formData,
      params: {},
      headers: {},
      successCallback: res => {
        this.props.removeAssessmentData();
        console.log("Assessment Submitted Successfully");
        this.setState({
          isSuccessModelOpen: true,
          apiLoading: false
        });
        // this.goBack();
      },
      failureCallback: err => {
        console.log("Error while submitting Assessment Submitted Successfully : ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  async goToViewAssessment() {
    const assessmentId = this.state.assessmentId;
    await this.props.setOnlineAssessmentStatus(false);
    await this.props.removeAssessmentData();
    this.props.history.push(appRoutes.instantHushViewCompletedAssessment + "/" + assessmentId, { _id: assessmentId });
  }

  render() {
    return (
      <div className="row rounded p-3 assessment-page">
        <div className="col-sm-12 p-3">
          <p onClick={() => this.goBack()}
             className="p-0 m-0 insta-link-orange font-15 text-decoration-none cursor-pointer">
            <i className="fas fa-arrow-left" />{" "}
            <img src={InstantHushLogo} alt="is_logo" className="instant-switch-back-button-logo ml-2" />
          </p>
        </div>

        <div className="w-100 border" />
        {
          this.state.assessmentData && (
            <Fragment>
              <div className="col-sm-4 p-0">
                {/* Left Side Patient Details */}
                <ViewAssessment auth={this.state.auth} assessmentData={this.state.assessmentData} />
              </div>
              <div className="col-sm-8 mt-4">
                <div className="card pt-3 pb-3">
                  <div className="row p-0 m-0">
                    {
                      (this.state.currentStep === 1) && (
                        <Fragment>
                          <div className="col-sm-12">
                            {/* First Type Selections like Over the counter "ERECTILE_DYSFUNCTION", "PREMATURE_EJACULATION", "SLEEP", "HAIR_LOSS" - which will be default */}
                            <TreatmentPlanSelectionForm addSelectedType={(types) => this.addSelectedType(types)}
                                                        assessmentType={this.state.assessmentData.assessmentType}
                                                        selectedType={this.state.selectedType} />
                          </div>
                          <div className="col-sm-12 mt-5">
                            <ICButton title="Reject Online Assessment" className="red"
                                      clickEvent={() => this.toggleRejectConfirmationModel()} />
                          </div>
                        </Fragment>
                      )
                    }

                    {/* Prescription Form Step 2*/}
                    {
                      this.state.currentStep === 2 && (
                        <Fragment>
                          <div className="col-sm-12 pt-2 pb-4">
                            <p onClick={() => this.decreaseCurrentStep()}
                               className="p-0 m-0 insta-link-orange font-15 text-decoration-none cursor-pointer pl-3">
                              <i className="fas fa-arrow-left" />{" "}
                              <span className="ml-1 pt-1 back-btn-text">
                                                                {" "}
                                Back to Step 1
                                                            </span>
                            </p>
                            <Prescription selectedType={this.state.selectedType} assessmentData={this.state.assessmentData}
                                          togglePrescriptionComponent={() => this.togglePrescriptionComponent()} />
                          </div>
                          {/* List of Prescriptions - Show Attached Prescriptions from the redux store */}
                          {
                            this.props.attachments.length ? (
                              <Fragment>
                                <div className="container-fluid mt-3 mb-3">
                                  <div className="row p-0 m-0">
                                    <div className="col-sm-6 pt-1">
                                      <Label title="Attached Prescriptions" className="secondary-font w-100" />
                                    </div>

                                    <div className="col-sm-12 mt-1 pb-4">
                                      {
                                        this.props.attachments.map((attachment, index) => {
                                          return (
                                            <div className="prescription-attachments cursor-pointer mr-2 mt-2" key={index}>
                                              <div className="pdf-text cursor-pointer"
                                                   onClick={() => this.openAttachment(attachment)}>
                                                <Label title="PDF" className="cursor-pointer" />
                                              </div>
                                              <div className="attachment-type-name cursor-pointer"
                                                   onClick={() => this.openAttachment(attachment)}>
                                                <Label title="ePrescription.pdf" className="cursor-pointer ml-3" />
                                              </div>
                                              <div className="delete-icon"
                                                   onClick={() => this.deleteAttachment(attachment, index)}>
                                                <i className="fas fa-times" />
                                              </div>
                                            </div>
                                          );
                                        })
                                      }
                                    </div>
                                    <div className="col-sm-12 mt-4 text-center">
                                      <ICButton title="Next" clickEvent={() => this.increaseCurrentStep()} />
                                    </div>
                                  </div>
                                </div>
                              </Fragment>
                            ) : (
                              ""
                            )
                          }
                        </Fragment>
                      )
                      // this.state.isPrescriptionFormVisible && (

                      // )
                    }

                    {
                      this.state.currentStep === 3 && (
                        <Fragment>
                          <div
                            className={
                              this.state.patientDetailsConfirmedError
                                ? "col-sm-12 custom-chk-lbl pl-4 chk-error"
                                : "col-sm-12 custom-chk-lbl pl-4"
                            }
                          >
                            <ICCheckbox
                              style={{ padding: 0, paddingRight: "5px" }}
                              name="patientDetailsConfirmed"
                              value={this.state.patientDetailsConfirmed}
                              className="font-12"
                              inputProps={{
                                "aria-label":
                                  "Patient ID, DOB and address confirmed"
                              }}
                              label="Patient ID, DOB and address confirmed"
                              onChange={e => {
                                this.setState({
                                  patientDetailsConfirmedError: !e.currentTarget.checked,
                                  patientDetailsConfirmed: e.currentTarget.checked
                                });
                              }}
                            />
                          </div>
                          <div className="container-fluid mt-3">
                            <div className="row p-0 m-0">
                              <div className="col-sm-6 pt-1">
                                <Label title="Additional Information for Consult Note" className="secondary-font w-100" />
                              </div>
                            </div>
                            <div className="col-sm-12 pt-2 pb-4 mt-1">
                              <ICInput
                                id="additionalNoteForConsultNote"
                                name="additionalNoteForConsultNote"
                                className="text-area"
                                label=""
                                multiline
                                rows="3"
                                onChange={(event) => {
                                  this.setState({
                                    additionalNoteForConsultNote: event.target.value
                                  });
                                }}
                                value={this.state.additionalNoteForConsultNote}
                              />
                            </div>
                          </div>

                          <div className="container-fluid mb-3">
                            <div className="row p-0 m-0">
                              <div className="col-sm-6 pt-1">
                                <Label title="Additional Information for Patient" className="secondary-font w-100" />
                              </div>
                            </div>
                            <div className="col-sm-12 pt-2 pb-4 mt-1">
                              <ICInput
                                id="additionalNoteForPatient"
                                name="additionalNoteForPatient"
                                className="text-area"
                                label=""
                                multiline
                                rows="3"
                                onChange={(event) => {
                                  this.setState({
                                    additionalNoteForPatient: event.target.value
                                  });
                                }}
                                value={this.state.additionalNoteForPatient}
                              />
                            </div>
                          </div>

                          <div className="container-fluid mb-3">
                            <div className="col-sm-12">

                              {/* Submit Assessment Button */}
                              <div className="col-sm-12 mt-4 pt-2 text-center">
                                <ICButton className="ml-3" title="Submit Treatment Plan"
                                          clickEvent={this.handleSubmitAssessment}
                                          disabled={this.state.selectedType.length ? false : true} />
                              </div>

                            </div>
                          </div>
                        </Fragment>
                      )
                    }

                  </div>
                </div>
              </div>
            </Fragment>
          )
        }

        {/* Success API Model  */}
        <Model
          openModal={this.state.isSuccessModelOpen}
          modalBodyContent={
            <p className="text-center mb-0">
              Assessment Submitted Successfully
            </p>
          }
          okayText="Save"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          cancelEvent={() => {
            // this.goBack();
            this.goToViewAssessment();
          }}
        />

        {/* Reject Assessment Confirmation Model */}
        <Model
          openModal={this.state.showRejectAssessmentConfirmationModel}
          modalBodyContent={
            <p className="text-center mb-0">
              Are you sure you want to reject this online assessment?
            </p>
          }
          okayText="Reject"
          cancelText="Close"
          title="Instant Consult"
          useOneButton={false}
          cancelEvent={() => {
            this.toggleRejectConfirmationModel();
          }}
          okayEvent={() => {
            this.rejectOnlineAssessment();
          }}
        />

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Loader */}
        <Loader loading={this.state.apiLoading} />
      </div>
    );
  }
}

// get the store
const mapStateToProps = props => ({
  auth: props.auth.user,
  constants: props.auth.user.appConstant,
  attachments: props.auth.attachments ? props.auth.attachments : [],
  prescriptionDrugs: props.auth.prescriptionDrugs ? props.auth.prescriptionDrugs : []
});

const mapDispatchToProps = dispatch => ({
  deleteNoteAttachment: data => dispatch(deleteNoteAttachment(data)),
  setOnlineAssessmentStatus: data => dispatch(setOnlineAssessmentStatus(data)),
  deleteDrugInfo: data => dispatch(deleteDrugInfo(data)),
  saveNoteAttachment: data => dispatch(saveNoteAttachment(data)),
  saveDrugInfo: data => dispatch(saveDrugInfo(data)),
  removeAssessmentData: () => dispatch(removeAssessmentData())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IhAssessmentViewPage));
